import React from 'react';
import HeroSection from '../components/HeroSection';
import Partners from '../components/Partners';
import HowItWorks from '../components/HowItWorks';
import KeyAreas from '../components/KeyAreas';
import AboutUs from '../components/AboutUs';
import Lost from '../components/Lost';
import Footer from '../components/Footer';
import SEO from '../components/SEO';

const LandingPage = () => {
  return (
    <>
      <SEO 
        title="Free Restaurant Online Ordering Assessment - Grow Your Orders | Order Portal"
        description="Take our free 5-minute assessment to discover how to increase your restaurant's online orders. Get customized insights for pizza, deli, Chinese, Mexican, Thai, Indian, Japanese, and all restaurant types. Boost customer engagement and ordering efficiency today."
        keywords="restaurant online ordering, online ordering for restaurants, restaurant assessment, online ordering system, restaurant website, pizza online ordering, deli online ordering, Chinese restaurant online ordering, Mexican restaurant ordering, Thai restaurant ordering, Indian restaurant ordering, restaurant growth, increase restaurant orders"
        canonical="https://orderportal.com/"
      />
      <main className="landing-page" role="main">
        <HeroSection />
        <Partners />
        <HowItWorks />
        <KeyAreas />
        <AboutUs />
        <Lost />
        <Footer />
      </main>
    </>
  );
};

export default LandingPage;
